import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'message-alert',
  templateUrl: './message-alert.html',
  styleUrls: ['./message-alert.scss']
})
export class MessageAlert implements OnInit {

  // private closeText: string = this.translate.instant('LABELS.CLOSE');

  @Input() options: any = {
    icon: '',
    img: '',
    html: '',
    header: '',
    buttons: [
      { btnText: this.translate.instant('LABELS.CLOSE') }
    ]
  };
  constructor(private modalCtrl: PopoverController, private translate: TranslateService) { }
  ngOnInit() {
    if (this.options.autoCloseTime) {
      setTimeout(() => {
        this.close(this.options.buttons.length ? this.options.buttons[0] : []);
      }, this.options.autoCloseTime);
    }
  }

  close(btn) {
    this.modalCtrl.dismiss(btn);
  }

  closeCrossButton() {
    this.modalCtrl.dismiss()
  }

}
